import * as Newsbrief from '../'
import * as Constants from './constants'

export const addEmailTemplate =
  (update: Newsbrief.UpdateStateAction) =>
  ({type: Constants.ADD_EMAIL_TEMPLATE, ...update})

export const updateTemplateField =
  (update: Newsbrief.UpdateStateAction) =>
  ({type: Constants.UPDATE_EMAIL_TEMPLATE, ...update})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/email-template/actions.ts